<template>
  <div>
    <v-card>
      <v-card-title primary-title>
        <v-layout row wrap>
          <v-flex xs12 text-xs-center>
            <h2>{{product.serial_number}}</h2>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-form v-on:submit.prevent="addItem" v-model="valid" ref="addItemForm">
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs4>
                <v-img v-if="picture" :src="picture" aspect-ratio="1.7"></v-img>
                <v-img v-else src="/img/img_not_found.png" aspect-ratio="1.7" contain></v-img>
              </v-flex>
              <v-flex xs8 class="card-item">
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-text-field
                      name="whole"
                      label="Completos"
                      id="whole"
                      type="number"
                      v-model="itemData.whole"
                      outline
                      @focus="$event.target.select()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      name="three-quarter"
                      label="Tres Cuartos"
                      id="three-quarter"
                      type="number"
                      v-model="itemData.three_quarter"
                      @focus="$event.target.select()"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      name="half"
                      label="Medio"
                      id="half"
                      type="number"
                      v-model="itemData.half"
                      @focus="$event.target.select()"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      name="one-quarter"
                      label="Un Cuarto"
                      id="one-quarter"
                      type="number"
                      v-model="itemData.quarter"
                      @focus="$event.target.select()"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      item-text="label"
                      item-value="value"
                      :items="hasSerialNumberOptions"
                      v-model="itemData.has_code"
                      label="Tiene Código"
                      outline
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      name="payed-price"
                      label="Precio Pagado"
                      id="payed-price"
                      v-model="itemData.payed_price"
                      @focus="$event.target.select()"
                      type="number"
                      outline
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <h3>{{product.description}}</h3>
              </v-flex>
              <v-flex xs4 text-xs-center>
                {{product.maker_name}}
              </v-flex>
              <v-flex xs4 text-xs-center>
                {{product.weigth_grams}}
              </v-flex>
              <v-flex xs4 text-xs-center>
                <span  class="font-weight-black" :style="{color: currentList.color}" >{{product.pesos_price * currentListPercentage | currency('$', 2)}}</span>
              </v-flex>
              <v-flex xs12 text-xs-right>
                <v-btn type="submit" color="success">Agregar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import { cachiosInstance } from '../../axios';

export default {
  props: [ 'product'],
  data() {
    return {
      hasSerialNumberOptions: [
        {label: 'Si', value: true},
        {label: 'No', value: false},
      ],
      itemData: {
        has_code: true,
        payed_price: 0.00,
        whole: 0,
        three_quarter: 0,
        half: 0,
        quarter: 0,
        serial_number: '',
        weigth: '',
      },
      valid: true,
      picture: '',
    };
  },
  computed: {
    currentList() {
      return this.$store.state.user.profile.currentList;
    },
    currentListPercentage() {
      if (this.$store.getters.getProfile && this.$store.getters.getProfile.currentList) {
        return this.$store.getters.getProfile.currentList.percentage / 100;
      }
      return 0;
    },
  },
  methods: {
    addItem() {
      if (this.isLineValid()) {
        this.itemData.serial_number = this.product.serial_number;
        this.itemData.weigth = this.product.weigth_grams;
        this.itemData.payed_price = parseFloat(this.itemData.payed_price, 10);

        this.itemData.whole = parseInt( this.itemData.whole, 10);
        this.itemData.three_quarter = parseInt( this.itemData.three_quarter, 10);
        this.itemData.half = parseInt(this.itemData.half, 10);
        this.itemData.quarter = parseInt(this.itemData.quarter, 10);

        this.itemData.type = 'CATALYST';

        this.$emit('add-item', this.itemData);
      } else {
        this.$emit('warning', 'Ingrese una cantidad de piezas');
      }
    },
    isLineValid() {
      const hasItems =
        this.itemData.whole > 0 || this.itemData.three_quarter > 0 || this.itemData.half || this.itemData.quarter > 0;
      return hasItems;
    },
    async retrieveImage() {
      await cachiosInstance.get(`/img/${this.product.picture_path}`)
        .then( (result) => {
          this.picture = result.data;
        })
        .catch( (error) => {
          return response;
        });
    },
  },
  mounted() {
    if (this.product.picture_path) {
      this.retrieveImage();
    }
  },
};
</script>